module.exports = __webpack_public_path__ + "static/media/cartoon_pic_list.396afa80.png";